import { Injectable } from '@angular/core';
import { ModalComponent, ModalProps } from '../common/components/modal/modal.component';
import { ButtonVariant } from '@amobee/component-library';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private _modal: ModalComponent;
    private defualtModalProps: ModalProps;

    set modal(modal: ModalComponent) {
        this._modal = modal;
        this.defualtModalProps = modal.modalProps;
    }

    openModal(modalProps: ModalProps) {
        this._modal.modalProps = Object.assign({}, this.defualtModalProps, modalProps);
        this._modal.openModal();
    }

    confirmation(bodyContent: { message: string; subMessage?: string }, callBack: any) {
        if (!bodyContent.subMessage) {
            bodyContent.subMessage = 'Click Confirm to continue, or click Cancel to stay on this page.';
        }
        this.openModal({
            closeButton: true,
            headerContent: 'Confirmation',
            bodyContent: bodyContent,
            footerContent: [
                {
                    label: 'Confirm',
                    variant: ButtonVariant.PRIMARY,
                    onConfirm: () => {
                        callBack();
                    }
                },
                {
                    label: 'Cancel'
                }
            ]
        });
    }

    error(bodyContent: { message: string; subMessage?: string }) {
        this.openModal({
            headerContent: 'Error',
            bodyContent: bodyContent,
        });
    }
}
